import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import ContactUsComponent from "../../Components/ContactUs/ContactUsComponent";
import { GetLocalStorageParsed } from "../utils/page";

const ContactUs = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const [loading, setLoading] = useState();

  const [loginToken, setLoginToken] = useState(FetchToken || null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [checkValue, setCheckValue] = useState(false);
  return (
    <>
      <div
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <Header setLoginToken={setLoginToken} setLoading={setLoading} />
        <ContactUsComponent
          setCheckValue={setCheckValue}
          checkValue={checkValue}
        />

        <Footer />
      </div>
    </>
  );
};

export default ContactUs;
